/**
 * Live search in the header.
 *
 * Without this file the search panel is still a normal form that submits to
 * the search page. With it, matching gift sets and collections appear while
 * typing, using Shopify's predictive search endpoint.
 */
(function () {
  'use strict';

  var details = document.querySelector('[data-predictive-search]');
  if (!details) return;

  var input = details.querySelector('[data-predictive-input]');
  var results = details.querySelector('[data-predictive-results]');
  var form = details.querySelector('form');
  if (!input || !results || !form) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var moneyFormat = results.getAttribute('data-money-format') || 'Rs. {{amount}}';
  var timer;
  var controller;
  var lastQuery = '';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(amount) {
    var number = parseFloat(amount);
    if (isNaN(number)) return '';
    var formatted = number.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function searchUrl(query) {
    return root + 'search?type=product&q=' + encodeURIComponent(query);
  }

  function render(query, data) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    var html = '';

    if (!products.length && !collections.length) {
      results.innerHTML = '<p class="predictive__empty">No gift sets match “' + escapeHtml(query) + '”. Try a word such as diary, bottle or notebook.</p>';
      return;
    }

    if (collections.length) {
      html += '<p class="predictive__heading">Collections</p><ul class="predictive__collections" role="list">';
      collections.forEach(function (c) {
        html += '<li><a href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a></li>';
      });
      html += '</ul>';
    }

    if (products.length) {
      html += '<p class="predictive__heading">Gift sets</p><ul class="predictive__products" role="list">';
      products.forEach(function (p) {
        var image = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        html += '<li><a class="predictive__product" href="' + escapeHtml(p.url) + '">' +
          (image ? '<img src="' + escapeHtml(imageUrl(image, 160)) + '" alt="" width="80" height="80" loading="lazy">' : '<span></span>') +
          '<span><span class="predictive__product-title">' + escapeHtml(p.title) + '</span>' +
          '<span class="predictive__price">' + escapeHtml(formatMoney(p.price)) + (p.available === false ? ' · Sold out' : '') + '</span></span>' +
          '</a></li>';
      });
      html += '</ul>';
    }

    html += '<a class="predictive__all" href="' + escapeHtml(searchUrl(query)) + '">View all results for “' + escapeHtml(query) + '”</a>';
    results.innerHTML = html;
  }

  function search(query) {
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;

    var url = root + 'search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (query === lastQuery) render(query, data);
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    lastQuery = query;
    window.clearTimeout(timer);
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }
    timer = window.setTimeout(function () { search(query); }, 220);
  });

  details.addEventListener('toggle', function () {
    if (details.open) {
      window.setTimeout(function () { input.focus(); }, 30);
    }
  });

  function closePanel() {
    if (!details.open) return;
    details.removeAttribute('open');
    details.querySelector('summary').focus();
  }

  details.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closePanel();
    }
  });

  document.addEventListener('click', function (event) {
    if (details.open && !details.contains(event.target)) details.removeAttribute('open');
  });
})();
